import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PrivacyPolicyModal } from '../PrivacyPolicyModal'
import { ContactUsModal } from '../ContactUsModal'
import { AboutUsModal } from '../../RightMain/AboutUsModal'
import {
  CopyrightFooter,
  CopyrightTextBox,
  CopyrightText,
  FooterLinks,
  FooterLink,
  FooterLinkDivider
} from './styles'

export const CopyrightNotice = ({ variant = 'mobile' }) => {
  const { t } = useTranslation()
  const [isAboutOpen, setIsAboutOpen] = useState(false)
  const [isPolicyOpen, setIsPolicyOpen] = useState(false)
  const [isContactOpen, setIsContactOpen] = useState(false)
  const currentLng = localStorage.getItem('i18nextLng') || 'ar'
  const isEnglish = currentLng === 'en'

  return (
    <CopyrightFooter variant={variant}>
      <CopyrightTextBox variant={variant}>
        <CopyrightText dir={isEnglish ? 'ltr' : 'rtl'} variant={variant}>
          {t(isEnglish ? 'Copyright Footer EN' : 'Copyright Footer AR')}
        </CopyrightText>
        <FooterLinks>
          <FooterLink
            type="button"
            variant={variant}
            onClick={() => setIsAboutOpen(true)}
          >
            {t('About Us')}
          </FooterLink>
          <FooterLinkDivider variant={variant}>|</FooterLinkDivider>
          <FooterLink
            type="button"
            variant={variant}
            onClick={() => setIsPolicyOpen(true)}
          >
            {t('Privacy Policy')}
          </FooterLink>
          <FooterLinkDivider variant={variant}>|</FooterLinkDivider>
          <FooterLink
            type="button"
            variant={variant}
            onClick={() => setIsContactOpen(true)}
          >
            {t('Contact Us')}
          </FooterLink>
        </FooterLinks>
      </CopyrightTextBox>
      <AboutUsModal open={isAboutOpen} onClose={() => setIsAboutOpen(false)} />
      <PrivacyPolicyModal open={isPolicyOpen} onClose={() => setIsPolicyOpen(false)} />
      <ContactUsModal open={isContactOpen} onClose={() => setIsContactOpen(false)} />
    </CopyrightFooter>
  )
}
